import React from "react";
import Marquee from "react-fast-marquee";
import { Briefcase, SteeringWheel } from "@phosphor-icons/react";
import { useLang } from "../../context/LanguageContext";

export const AnnouncementBar = ({ onNav }) => {
  const { t } = useLang();
  const msg = t("hiring");
  return (
    <div
      onClick={() => onNav && onNav("drive")}
      className="fixed top-0 left-0 right-0 z-[90] h-9 bg-black text-taxi flex items-center overflow-hidden cursor-pointer border-b border-taxi/30"
      data-testid="announcement-bar"
    >
      <Marquee speed={45} gradient={false} autoFill>
        <div className="flex items-center gap-3 mx-8">
          <SteeringWheel size={16} weight="fill" />
          <span className="text-xs md:text-sm font-extrabold uppercase tracking-wider">{msg}</span>
          <Briefcase size={14} weight="fill" className="text-taxi/70" />
        </div>
      </Marquee>
    </div>
  );
};
